import React from 'react';
//import { render } from 'react-dom';
//import { Provider } from 'react-redux';
//import { HashRouter as Router } from "react-router-dom";
import { Header } from './components/common/header';
//import { Footer } from './components/common/';
import Content from './content.js';
import './css/custom.css';
import { authProvider } from './authProvider';
import { AzureAD, AuthenticationState } from 'react-aad-msal';


export default class App extends React.Component {
    render() {

        return (
            <AzureAD provider={authProvider} forceLogin={true}>
                {
                    ({authenticationState,accounyInfo }) => {
                return (
                
                authenticationState === AuthenticationState.Authenticated &&
                <div>
                   <Header />
                                <main className="full-width" id="ddsi-root">
                                    <Content />
                                </main>


                </div>
        );
                }}
            </AzureAD>
        );
    }
}

//render(
//    <Provider store={store}>
//        <Router>
//            <App />
//        </Router>
//    </Provider>,
//    document.getElementById('root')
//);
